import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { VariantsOrderAmountFormInput } from './input-form.component';

export default [
    registerFormInputComponent(
        'variants-order-amount-form-input',
        VariantsOrderAmountFormInput
    ),
];
